<template>
  <component :is="entryComponent" @success="$emit('success')" @back="$emit('back')"></component>
</template>

<script>
import { mapGetters } from "vuex";
import ScratchCard from "@/application/components/ScratchCard";
import ScratchCardManual from "@/application/components/ScratchCardManual";
import { hasPendingPurchaseScratchCardSSCE } from "@/application/lib/scratchCardEntry";

export default {
  name: "ScratchCardEntry",
  components: { ScratchCard, ScratchCardManual },

  computed: {
    ...mapGetters(["getSSCEDetails", "getUser"]),

    automaticPurchasesEnabled() {
      return (this.getUser?.admission?.applicationType?.autoScratchCards?.length ?? 0) > 0
    },

    entryComponent() {
      return hasPendingPurchaseScratchCardSSCE(this.getSSCEDetails, this.automaticPurchasesEnabled)
        ? "scratch-card"
        : "scratch-card-manual"
    }
  }
}
</script>
